
import { SFConstants } from "../../../constants/SFConstants";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Command } from "../Poker2Command";

export class BGACommand extends Poker2Command {
    protected get cmdId(): string {
        return "bga";
    }
    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);
            Poker2Model.buddyList.addIngameBuddyAvatarInfo(paramObj);
            if (this.env.hasNetworkBuddies)
                Poker2Model.buddyList.getSocialBuddyData();

            Poker2Model.sessionData.initSessionTime(Poker2Model.sessionData.BUDDY_ONLINEREQUEST_INTERVAL, Poker2Model.sessionData.BUDDY_ONLINEREQUEST_TIMER);
        }
        return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
